<template>
    <div id="app">
        <header>
            <block-header
                :bootstrapped="bootstrapped"
            />
        </header>
        <main ref="main" tabindex="-1">
            <div
                v-if="loading"
                aria-label="loading"
                role="alert"
                tabindex="-1"
                class="loading"
            >
                <spinner :message="loadingMessage" />
            </div>
            <div v-if="bootstrapped">
                <router-view
                    v-show="!loading"
                    :key="$route.fullPath"
                    @loading="onLoading"
                />
            </div>
            <slot />
        </main>
        <footer>
            <block-footer />
        </footer>
    </div>
</template>

<script>
import "./assets/theme.scss";

import BlockHeader from "./components/blocks/BlockHeader";
import BlockFooter from "./components/blocks/BlockFooter";

export default {
    name: "Midttrafik",
    components: {
        BlockHeader,
        BlockFooter
        },
    props: {
        loading: Boolean,
        loadingMessage: { type: String, required: false, default: "" },
        onLoading: { type: Function, default: () => {} },
        bootstrapped: { type: Boolean, required: true }
    },
    watch: {
        loading: function() {
            this.$nextTick(function() {
                this.$refs.main.focus({ preventScroll: true });
            });
        },
        $route: function() {
            this.$nextTick(function() {
                this.$refs.main.focus({ preventScroll: true });
            });
        }
    },
    mounted() {
        this.$nextTick(function() {
            this.$refs.main.focus({ preventScroll: true });
        });
    }
};
</script>

<style scoped>
#app {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

main {
    flex: 1 0 auto;
    padding-bottom: 4rem;
    outline: none;
}

.loading {
    margin-top: 5rem;
    text-align: center;
    outline: none;
}
</style>
